import { Validator } from 'jsonschema';
import catalogConfig from '../config/catalogConfig.mjs';
const validator = new Validator();
export default (trigger, config) => {
    const { errors } = validator.validate(trigger.params || {}, buildSchema(config));
    return errors.map(String);
};
const buildSchema = (triggerConfig) => {
    const schemas = determineParamSchemas(triggerConfig);
    return {
        $schema: 'http://json-schema.org/draft-04/schema#',
        type: 'object',
        properties: schemas,
        required: Object.keys(schemas),
    };
};
const determineParamSchemas = (triggerConfig) => {
    const schemas = {
        ...catalogConfig.defaultEventParameters,
        ...(triggerConfig.schema || {}),
    };
    // Don't validate params which values are already provided by default
    [...Object.keys(triggerConfig.event.params || {}), 'context', 'feature'].forEach((name) => {
        delete schemas[name];
    });
    return schemas;
};
